import React from 'react';
import Toast from 'react-native-root-toast';
import { useMutation } from '@apollo/client';

import { GET_MACHINES_FOR_SERVICE_RUN_CREATOR } from '../../../common/graphql/machine';
import { CHANGE_SERVICE_RUN_MACHINES } from '../../../common/graphql/serviceRun';
import { useForm } from '../../../common/utils/hooks';

import useReportDockAction from '../../hooks/useReportDockAction';

import ServiceRunCreatorMachineList from './ServiceRunFormMachineList';
import { useUserContext } from '../../../common/utils';

const ServiceRunEditor = ({
	initialValues,
	routeId,
	serviceRunId,
	navigation,
	onDockChange,
}) => {
	const [changeServiceRunMachinesMutation, { loading }] = useMutation(CHANGE_SERVICE_RUN_MACHINES);

	const onSubmit = async () => {

		await changeServiceRunMachinesMutation({
			variables: {
				serviceRunId,
				machineIds: values.machines,
			},
		});

		navigation.replace('ServiceRunDetailView', { id: serviceRunId });
		Toast.show('Service run updated');
	};

	const { values, changeFormValue } = useForm(initialValues, onSubmit);
	const { tenantSettings } = useUserContext();

	useReportDockAction(onDockChange, {
		label: `Update machines${tenantSettings.usesMarkets ? '/markets' : ''}`,
		onPress: onSubmit,
		loading,
	});

	return (
		<ServiceRunCreatorMachineList
			query={GET_MACHINES_FOR_SERVICE_RUN_CREATOR}
			initialFilter={{ route: routeId }}
			initialSortBy="vendouts"
			initialPerPage={50}
			values={values}
			changeFormValue={changeFormValue}
			listId="mobile_machines_sr"
		/>
	);
};

export default ServiceRunEditor;
